export function calcScrollToOptions(
  el: HTMLElement,
  offset = 0,
): ScrollToOptions {
  const rect = el.getBoundingClientRect();
  const scrollTop = window.scrollY || window.pageYOffset;
  const scrollLeft = window.scrollX || window.pageXOffset;

  return {
    top: rect.top + scrollTop - offset,
    left: rect.left + scrollLeft - offset,
  } satisfies ScrollToOptions;
}

type To = `.${string}` | `#${string}` | HTMLElement;

export interface UseScrollParams {
  to: To;
  behavior?: ScrollBehavior;
  offset?: number;
}

function resolveTo(to: To): HTMLElement | null {
  if (typeof to === "string") {
    if (to.startsWith("#")) {
      const elById = document.getElementById(to.replace(/^[.#]/, ""));
      if (elById) return elById as HTMLElement;
    }
    if (to.startsWith(".")) {
      const elByClass = document.querySelector(to.replace(/^[.#]/, ""));
      if (elByClass) return elByClass as HTMLElement;
    }
    return document.querySelector(to) as HTMLElement;
  }
  return to;
}

export function useScroll() {
  return (params: UseScrollParams) => {
    return (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      const el = resolveTo(params.to);
      if (!el) {
        const id = params.to instanceof Element ? params.to.id : params.to;
        console.error(`Element with id "${id}" not found.`);
        return;
      }

      const scrollToOptions: ScrollToOptions = {
        behavior: params.behavior ?? "smooth",
        ...calcScrollToOptions(el, params.offset),
      };

      window.scrollTo(scrollToOptions);
      window.history.replaceState({}, "", `${location.pathname}#${el.id}`);
    };
  };
}
